export default [
    {
        path: '/:cid/note',
        name: 'notes',
        meta: {
            title: "Notes",
            requiresAuth: true
        },
        component: () => import('@/views/Notes/Notes.vue'),
    },
]